export const BOOKING_OPTION_MODEL = "booking-option";

const bookingOptionModel = {
  requireCv: false,
  requireExperience: false,
  requireQualifications: false
};

export default bookingOptionModel;
